export function initializeTextReveal() {
    gsap.registerPlugin(ScrollTrigger);

    var textRevealElements = document.querySelectorAll(".text-reveal");

    textRevealElements.forEach(element => {
        var mySplitText = new SplitText(element, {
            type: "lines, words",
            linesClass: "line"
        });

        var words = mySplitText.words; 

        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: element, 
                start: "top 90%", 
                end: "bottom 20%", 
                toggleActions: "play none none none", 
                markers: false 
            }
        });

        tl.from(words, {
            duration: 1,
            opacity: 0,
            yPercent: 100,
            ease: "power",
            stagger: 0.02
        });
    });
}
